import React from "react";
import { DashboardIcon as icon } from '@frontend-components/admin/es/resources/icons';

export default {
    appId: "dashboard",
    appType: "dashboard",
    name: "dashboard",
    icon: icon,
    title: "Dashboard"
};